import { DarkMode, LightMode } from '@mui/icons-material'
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material'
import React from 'react'

const Navbar = ({theme,setTheme}) => {
  return (
    <AppBar position='sticky'>
        <Toolbar sx={{display:'flex',justifyContent:'space-evenly',alignItems:'center'}}>
            <Typography variant='h6' >
                IP App
            </Typography>
            <IconButton sx={{color: theme === 'light' ? 'orange' :'white'}} onClick={()=>setTheme(theme === 'light' ? 'dark' :'light')}>
                {theme === 'light' ? <LightMode /> : <DarkMode />}
            </IconButton>
        </Toolbar>
    </AppBar>
  )
}

export default Navbar